export const environment = {
    production: true,
    apiURL: '/api',
    assetsPath: '/assets/',
    trackNavigationHistory: true,
    googleAnalyticsKey: '',
    bannerClass: '',
    modeName: '',
    routeReuseDefault: true
};
